// Sales services.
//
// The backend endpoints are not available yet. These stubs define the intended
// request/response contract so the UI can be fully wired now and swapped to
// real Axios calls later — just uncomment the Axios lines and add the matching
// entries to ApiConstant (e.g. salesConstants.SEARCH / .SAVE).
//
// import Axios from "../../../axios.js";
// import {salesConstants} from "../../../constants/ApiConstant";

// VAT rate applied when a sale is marked VAT-applicable (Nepal standard 13%).
export const VAT_RATE = 0.13;

export const PAYMENT_STATUSES = [
    {value: "PAID", label: "Paid"},
    {value: "PENDING", label: "Pending"},
    {value: "PARTIAL", label: "Partial"},
    {value: "FAILED", label: "Failed"},
    {value: "REFUNDED", label: "Refunded"},
];

export const PAYMENT_MODES = [
    {value: "CASH", label: "Cash"},
    {value: "BANK_TRANSFER", label: "Bank Transfer"},
    {value: "ESEWA", label: "eSewa"},
    {value: "KHALTI", label: "Khalti"},
    {value: "CARD", label: "Card"},
    {value: "CHEQUE", label: "Cheque"},
];

// Compute the money breakdown for a sale from the raw amount/discount inputs.
export function computeSaleTotals({amount, discount, vatApplicable}) {
    const amt = Number(amount) || 0;
    const disc = Number(discount) || 0;
    const subtotal = Math.max(0, amt - disc);
    const vatAmount = vatApplicable ? subtotal * VAT_RATE : 0;
    const total = subtotal + vatAmount;
    return {subtotal, vatAmount, total};
}

// Format a number as NPR currency for display.
export function formatCurrency(value) {
    const num = Number(value) || 0;
    return `Rs. ${num.toLocaleString("en-IN", {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
}

export async function searchSales(params, page, size) {
    // return Axios.post(salesConstants.SEARCH + `?page=${page}&size=${size}`, params);
    return Promise.resolve({status: 200, data: {totalItems: 0, salesList: []}});
}

export async function saveSale(params) {
    // return Axios.post(salesConstants.SAVE, params);
    return Promise.resolve({status: 201, data: {...params, id: `local-${Date.now()}`}});
}
